import { Link } from "@tanstack/react-router"
import { ChevronRight } from "lucide-react"
import type { DashboardStatsCardProps } from "~/features/dashboard/pages/quick-actions/types/prop.types"

const StatsCard = ({ title, amount, url, initial }: DashboardStatsCardProps) => {
  return (
    <>
      {url && initial ? (
        <Link
          to={url}
          className="relative flex px-6 py-4 gap-4 border border-[#DCDCDE] shadow-sm bg-white rounded w-full justify-between items-center cursor-pointer group overflow-hidden
                     before:absolute before:top-0 before:left-[-100%] before:w-full before:h-full before:bg-gradient-to-r before:from-transparent before:via-slate-900/15 before:to-transparent before:skew-x-12 before:transition-all before:duration-500 before:ease-out
                     hover:before:left-[100%]
                     hover:border-slate-300 transition-all duration-300
                     after:absolute after:inset-0 after:rounded after:bg-gradient-to-br after:from-slate-900/3 after:via-slate-800/5 after:to-slate-900/3 after:opacity-0 after:transition-opacity after:duration-500
                     hover:after:opacity-100"
          role="stats-card"
          aria-label="stats-card"
          aria-colcount={1}
        >
          <div className="relative z-20 flex w-full justify-between items-center">
            <div className="flex flex-col gap-2 items-start">
              <h1 className="text-2xl font-bold text-[#1A202C]">{amount}</h1>
              <h2 className="text-sm font-normal">{title}</h2>
            </div>

            <div
              className="text-sm font-semibold bg-slate-100 p-[6px] rounded-full cursor-pointer group-hover:bg-slate-200 transition-colors duration-300"
              aria-label="open-dialog"
              id={`${title}-open-dialog`}
            >
              <ChevronRight className="w-5 h-5 text-[#7F8493] group-hover:text-slate-600 transition-colors duration-300" />
            </div>
          </div>
        </Link>
      ) : (
        <Link
          className="flex px-6 py-4 gap-4 border border-[#DCDCDE] shadow-sm bg-white rounded w-full justify-between items-center cursor-pointer"
          role="stats-card"
          aria-label="stats-card"
          aria-colcount={1}
          to={url}
        >
          <div className="relative z-20 flex w-full justify-between items-center"> 
          <div className="flex flex-col gap-2 items-start">
            <h1 className="text-2xl font-bold text-[#1A202C]">{amount}</h1>
            <h2 className="text-sm font-normal">{title}</h2>
          </div>
          <div className="text-sm font-semibold bg-slate-100 p-[6px] rounded-full cursor-pointer group-hover:bg-slate-200 transition-colors duration-300"
              aria-label="open-dialog"
              id={`${title}-open-dialog`}
            >
              <ChevronRight className="w-5 h-5 text-[#7F8493] group-hover:text-slate-600 transition-colors duration-300" />
            </div>
          </div>
        </Link>
      )}
    </>
  )
}

export default StatsCard
